import React, { PropsWithChildren, useRef } from 'react';

import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';

import bem from '../../../../lib/bemUtils/bem';

import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';

export enum ExtendedInfoModifier {
  RED = 'red',
}

export type ExtendedInfo = {
  helpText: string;
  tooltipPlacement: TooltipPlacement;
  modifier?: Modifier<ExtendedInfoModifier>;
};

/**
 * This component generates a Symbol for semantic differentiations.
 * For example used to show if something is read-protected.
 * You can tab it but can not click it like a button.
 */
export function ExtendedInfo(props: PropsWithChildren<ExtendedInfo>) {
  const spanRef = useRef<HTMLSpanElement>(null);
  const id = useHtmlValidId();

  return (
    <Tooltip placement={props.tooltipPlacement} hideTooltipFromScreenReader attachTo={spanRef} hideOnClick={false}>
      <span
        title={props.helpText}
        role="note"
        ref={spanRef}
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
        tabIndex={0}
        className={bem('extended-info', props.modifier)}
        aria-labelledby={id}
      >
        <span className="extended-info__icon">
          <span className="invisible" id={id}>
            {props.helpText}
          </span>
          {props.children}
        </span>
      </span>
    </Tooltip>
  );
}
